/** Intrinsic SVG size is 157×132; rendered at height 150 with matching aspect ratio. */
export const ILLUSTRATION_SIZE = {
  width: 178,
  height: 150,
} as const;
